if (!customElements.get('featured-collection-tabs')) {
  customElements.define(
    'featured-collection-tabs',
    class FeaturedCollectionTabs extends HTMLElement {
      constructor() {
        super();
        this.tabsContainer = this.querySelector('.featured-collection-tabs__tabs');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.isDragging = false;
        this.touchStartX = 0;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick.bind(this, tab));
        });

        if (this.tabsContainer) {
          this.tabsContainer.addEventListener('keydown', this.onKeydown.bind(this));

          // 触屏横向滑动 Tab 栏时，避免松手误触点击
          this.tabsContainer.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
          this.tabsContainer.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
          this.tabsContainer.addEventListener('touchend', this.onTouchEnd.bind(this));
        }
      }

      onTouchStart(event) {
        this.touchStartX = event.touches[0].clientX;
        this.isDragging = false;
      }

      onTouchMove(event) {
        if (Math.abs(event.touches[0].clientX - this.touchStartX) > 8) {
          this.isDragging = true;
        }
      }

      onTouchEnd() {
        window.setTimeout(() => {
          this.isDragging = false;
        }, 0);
      }

      onKeydown(event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const currentIndex = this.tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        const nextTab = this.tabs[(currentIndex + direction + this.tabs.length) % this.tabs.length];
        nextTab.focus();
        this.selectTab(nextTab);
      }

      onTabClick(tab) {
        if (this.isDragging) return;
        this.selectTab(tab);
      }

      selectTab(tab) {
        const targetId = tab.getAttribute('aria-controls');
        if (!targetId) return;

        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.classList.toggle('is-active', isActive);
          item.tabIndex = isActive ? 0 : -1;
        });

        // View all 链接跟随当前 Tab 的 Collection
        const collectionUrl = tab.getAttribute('data-fct-collection-url');
        if (collectionUrl) {
          this.querySelectorAll('[data-fct-view-all]').forEach((link) => {
            link.setAttribute('href', collectionUrl);
          });
        }

        this.scrollTabIntoView(tab);

        this.panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.hidden = !isActive;

          if (!isActive) return;

          const slider = panel.querySelector('[id^="Slider-"]');
          if (slider) slider.scrollLeft = 0;

          // 面板从 hidden 变为可见后重新计算滑块分页
          const sliderComponent = panel.querySelector('slider-component');
          if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
            sliderComponent.resetPages();
          }
        });
      }

      scrollTabIntoView(tab) {
        if (!this.tabsContainer) return;

        const containerRect = this.tabsContainer.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const offset = 16;

        if (tabRect.left < containerRect.left) {
          this.tabsContainer.scrollTo({
            left: this.tabsContainer.scrollLeft + tabRect.left - containerRect.left - offset,
            behavior: 'smooth',
          });
        } else if (tabRect.right > containerRect.right) {
          this.tabsContainer.scrollTo({
            left: this.tabsContainer.scrollLeft + tabRect.right - containerRect.right + offset,
            behavior: 'smooth',
          });
        }
      }
    }
  );
}
